module.exports = __webpack_public_path__ + "img/preferred-golden.9e8bac6d.svg";